import {Component, inject} from '@angular/core';
import {EchoChannelService} from "../../sevices/echo-channel.service";
import {Observable, filter, map, merge, of, take, tap, combineLatest, combineAll, mergeAll, mergeWith} from "rxjs";
import { UserNotificationService } from '../../sevices/user-notification.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';


@Component({
  selector: 'lcms-alert-simple',
  templateUrl: './alert-simple.component.html',
  styleUrls: ['./alert-simple.component.scss'],
})
export class AlertSimpleComponent {
  echo = inject(EchoChannelService)
  userNotif=inject(UserNotificationService)
  sanitizer=inject(DomSanitizer);
  itemsBean$:Observable<any>=this.echo.subjectBan.asObservable();
  itemsUser$:Observable<any>=this.userNotif.getUserNotif().pipe(
    map((data:any)=>data?.data),
    map((data:any)=>{
      return data.filter((dt:any)=>dt?.type==='BANNER')
    }),
  );
  items$: Observable<any> = combineLatest([this.itemsUser$, this.itemsBean$]).pipe(
    map(([userItems, beanItems]) => {
      return [...userItems, ...beanItems];
    })
  );
  close(id : any , index :any) {
    this.items$.pipe(
      map(items => items.filter((item:any) => item.id !== id)),
      take(1)
    ).subscribe()
    this.echo.rmBanner(id)
  }

  santizeHTML(value:string):SafeHtml{
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }
}
